import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import AutocompleteSelect from '../../../Widgets/AutocompleteSelect/AutocompleteSelect';

const ProblematicCardsModal = ({
    open,
    onClose,
    t,
    direction,
    modalStyle,
    problematicActions,
    problematicCards,
    handleSelectActionType,
    handleSelectExistingCard,
    formattedAccountCardOptions,
    handleSaveProblematicCards,
    loading
}) => (
    <Modal
        open={open}
        onClose={onClose}
        sx={{ borderRadius: '20px', textAlign: 'right' }}
    >
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '45%',
                maxHeight: '80%',
                bgcolor: 'white',
                boxShadow: 24,
                p: 4,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
            }}
        >
            <h2>{t('ProblematicCardsFound')}</h2>
            <p>{t('ChooseHowToHandleEachCard')}</p>
            {problematicActions.map((item, index) => {
                const createDto = problematicCards[index];
                item.accountCard = createDto;
                return (
                    <div
                        key={index}
                        style={{
                            border: '1px solid gray',
                            margin: '8px 0',
                            padding: '8px',
                            borderRadius: '4px',
                            width: '80%',
                            textAlign: 'right',
                        }}
                    >
                        <p>
                            <strong>{t('AccountCard ID')}:</strong> {createDto.cardId}
                        </p>
                        <p>
                            <strong>{t('AccountCard Name')}:</strong> {createDto.name}
                        </p>
                        <div style={{ marginTop: '8px' }}>
                            <label style={{ marginRight: '8px' }}>{t('ActionType')}</label>
                            <AutocompleteSelect
                                options={[
                                    { value: 0, label: t('CreateNewCard') },
                                    { value: 1, label: t('UseExistingCard') },
                                ]}
                                selectedValues={
                                    item.actionType === 0
                                        ? { value: 0, label: t('CreateNewCard') }
                                        : { value: 1, label: t('UseExistingCard') }
                                }
                                onChange={(event, newValue) => {
                                    if (newValue) handleSelectActionType(index, newValue.value);
                                }}
                                isMultiple={false}
                                width="100%"
                                placeholder={t('ActionType')}
                                isDisabled={false}
                            />
                        </div>
                        {item.actionType === 1 && (
                            <div style={{ marginTop: '8px' }}>
                                <label style={{ marginRight: '8px' }}>{t('SelectExistingCard')}</label>
                                <AutocompleteSelect
                                    options={formattedAccountCardOptions}
                                    selectedValues={
                                        formattedAccountCardOptions.find(
                                            (opt) => opt.value === item.cardIdToReplace
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        if (newValue) handleSelectExistingCard(index, newValue.value);
                                        else handleSelectExistingCard(index, null);
                                    }}
                                    isMultiple={false}
                                    width="100%"
                                    placeholder={t('SelectExistingCard')}
                                    isDisabled={false}
                                />
                            </div>
                        )}
                    </div>
                );
            })}
            <Button
                onClick={handleSaveProblematicCards}
                disabled={loading}
                variant="contained"
                sx={{ marginTop: '16px' }}
            >
                {t('Save')}
            </Button>
        </Box>
    </Modal>
);

export default ProblematicCardsModal;
